import PropTypes from 'prop-types';

export const BRAZIL_STATES = [
  { code: 'AC', name: 'Acre', region: 'Norte' },
  { code: 'AL', name: 'Alagoas', region: 'Nordeste' },
  { code: 'AM', name: 'Amazonas', region: 'Norte' },
  { code: 'AP', name: 'Amapá', region: 'Norte' },
  { code: 'BA', name: 'Bahia', region: 'Nordeste' },
  { code: 'CE', name: 'Ceará', region: 'Nordeste' },
  { code: 'DF', name: 'Distrito Federal', region: 'Centro-Oeste' },
  { code: 'ES', name: 'Espírito Santo', region: 'Sudeste' },
  { code: 'GO', name: 'Goiás', region: 'Centro-Oeste' },
  { code: 'MA', name: 'Maranhão', region: 'Nordeste' },
  { code: 'MG', name: 'Minas Gerais', region: 'Sudeste' },
  { code: 'MS', name: 'Mato Grosso do Sul', region: 'Centro-Oeste' },
  { code: 'MT', name: 'Mato Grosso', region: 'Centro-Oeste' },
  { code: 'PA', name: 'Pará', region: 'Norte' },
  { code: 'PB', name: 'Paraíba', region: 'Nordeste' },
  { code: 'PE', name: 'Pernambuco', region: 'Nordeste' },
  { code: 'PI', name: 'Piauí', region: 'Nordeste' },
  { code: 'PR', name: 'Paraná', region: 'Sul' },
  { code: 'RJ', name: 'Rio de Janeiro', region: 'Sudeste' },
  { code: 'RN', name: 'Rio Grande do Norte', region: 'Nordeste' },
  { code: 'RO', name: 'Rondônia', region: 'Norte' },
  { code: 'RR', name: 'Roraima', region: 'Norte' },
  { code: 'RS', name: 'Rio Grande do Sul', region: 'Sul' },
  { code: 'SC', name: 'Santa Catarina', region: 'Sul' },
  { code: 'SE', name: 'Sergipe', region: 'Nordeste' },
  { code: 'SP', name: 'São Paulo', region: 'Sudeste' },
  { code: 'TO', name: 'Tocantins', region: 'Norte' },
];

export const REGIONS = ['Norte', 'Nordeste', 'Centro-Oeste', 'Sudeste', 'Sul'];

// Original color references:
// Norte: rgb(255, 205, 205)
// Nordeste: rgb(205, 245, 205)
// 'Centro-Oeste': rgb(255, 245, 205)
// Sudeste: rgb(209, 217, 255)
// Sul: rgb(213, 213, 213)

// Sugestão de novas cores:
// Norte: --red-vivid-10 / FDE0DB
// Nordeste: --green-warm-10 / E7EAB7
// 'Centro-Oeste': --yellow-10 / F5E6AF
// Sudeste: --blue-warm-vivid-10 / D4E5FF
// Sul: --orange-vivid-10 / FCE2C5

export const REGION_COLORS = Object.freeze({
  Norte: Object.freeze({
    fill: 'var(--red-vivid-10)',
    hover: 'var(--red-vivid-20)',
    label: 'var(--red-vivid-60)',
    labelLink: 'var(--red-vivid-70)',
  }),
  Nordeste: Object.freeze({
    fill: 'var(--mint-10)',
    hover: 'var(--mint-20)',
    label: 'var(--mint-70)',
    labelLink: 'var(--mint-80)',
  }),
  'Centro-Oeste': Object.freeze({
    fill: 'var(--yellow-5)',
    hover: 'var(--yellow-10)',
    label: 'var(--yellow-70)',
    labelLink: 'var(--yellow-80)',
  }),
  Sudeste: Object.freeze({
    fill: 'var(--blue-warm-vivid-10)',
    hover: 'var(--blue-warm-vivid-20)',
    label: 'var(--blue-warm-vivid-70)',
    labelLink: 'var(--blue-warm-vivid-80)',
  }),
  Sul: Object.freeze({
    fill: 'var(--gray-10)',
    hover: 'var(--gray-20)',
    label: 'var(--gray-70)',
    labelLink: 'var(--gray-80)',
  }),
});

export const STATE_CODE_TO_REGION = BRAZIL_STATES.reduce((acc, state) => {
  acc[state.code] = state.region;
  return acc;
}, {});

export const STATE_CODES = BRAZIL_STATES.map((state) => state.code);

export const STATE_CODE_TO_NAME = BRAZIL_STATES.reduce((acc, state) => {
  acc[state.code] = state.name;
  return acc;
}, {});

export const getStateFieldName = (code) => `link${code}`;

export const STATE_FIELD_NAMES = BRAZIL_STATES.map((state) =>
  getStateFieldName(state.code),
);

export const STATE_PROP_TYPES = BRAZIL_STATES.reduce((acc, state) => {
  acc[getStateFieldName(state.code)] = PropTypes.string;
  return acc;
}, {});

export const linkMapDataShape = PropTypes.shape({
  title: PropTypes.string,
  linkTemplate: PropTypes.string,
  ...STATE_PROP_TYPES,
});

export const getNameStateByCode = (code) =>
  BRAZIL_STATES.find((state) => state.code === code.toUpperCase())?.name;
